<template>
  <eden-filter :width="270" :properties.sync="properties" :disabled="disabled" :loading="loading" @open="getData"
    @reset="reset" @filter="filter" />
</template>

<script>

export default {
  name: "ReviewsFilter",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: true,
      properties: {
        rating: {
          key: "rating",
          label: "Ratings",
          type: "list",
          options: [
            {
              label: "5 Stars",
              value: 5,
            },
            {
              label: "4 Stars",
              value: 4,
            },
            {
              label: "3 Stars",
              value: 3,
            },
            {
              label: "2 Stars",
              value: 2,
            },
            {
              label: "1 Star",
              value: 1,
            },
          ],
          value: [],
        },
        order_type: {
          key: "order_type",
          label: "Order Type",
          type: "list",
          options: [
            {
              label: "Subscription",
              value: "subscription",
            },
            {
              label: "Anytime",
              value: "anytime",
            },
          ],
          value: [],
        },
        date: {
          key: ["start_date", "end_date"],
          label: "Date Created",
          type: "daterange",
          value: [],
        },
      },
    };
  },
  watch: {
    clear() {
      if (this.clear) {
        this.reset();
      }
    },
  },
  methods: {
    getData() {
      this.loading = false;
      Object.keys(this.properties).forEach((key) => {
        this.properties[key].value = [];
      });
    },
    reset() {
      Object.keys(this.properties).forEach((key) => {
        this.properties[key].value = [];
      });
    },
    filter() {
      let params = {
        params: {},
        paramsLabel: {},
      };

      Object.keys(this.properties).forEach((property) => {
        const { key, type, value } = this.properties[property];
        if (value && value.length) {
          switch (type) {
            case "list":
              params.params[key] = value[0];
              params.paramsLabel[key] = this.properties[property];
              break;
            case "list-multiple":
              params.params[key] = value;
              params.paramsLabel[key] = this.properties[property];
              break;
            case "daterange":
              params.params[key[0]] = this.properties[property].value[0];
              params.params[key[1]] = this.properties[property].value[1];
              params.paramsLabel[key] = this.properties[property];
              break;
            default:
              break;
          }
        }
      });
      if (Object.keys(params.params).length) {
        this.$emit("filter", {
          params: params.params,
          paramsLabel: params.paramsLabel,
        });
      } else {
        this.$message.info("Filtering requires at least one property");
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
